import React, { useState, useEffect, useCallback } from 'react';
import { groupsStatisticsActions } from './actions';
import DiseaseSpecializationFilter from '../../../../../components/DiseaseSpecializationFilter/DiseaseSpecializationFilter';
import { 
  normalPlaceForGroups, 
  TYPE_SANAORNIY, 
  types_places, 
  types_zdo, 
  types_grups 
} from './constants/groupsConstants';
import StatisticaInvites from './Statistica_invites';
import StatisticaAttendanceGroup from './Statistica_attendance_group';
import { filters_tmpl } from '../../../../../components/DiseaseSpecializationFilter/data';
import './StatisticsGroups.css';

const auth = {
    getData: ()=>({
        privilegedUser:{
            role: 'superadmin'
        }
    })
};

const StatisticaGroups = ({ isArchive, id }) => {

  console.log({function: "StatisticaGroups", isArchive })
  // 1. Данные для отображения
  const [infoGr, setInfoGr] = useState([]);
  const [years, setYears] = useState([]);
  const [setDistr, setSetDistr] = useState([]);
  const [setSpec, setSetSpec] = useState([]);
  const [gr_full, setGrFull] = useState([]);
  
  // 2. Фильтры и выборы
  const [filters, setFilters] = useState({
    selYear: '',
    selDist: 'all',
    selSpec: 'all',
    selAge: 'all',
    selType: 'all',
    selTypeKg: types_zdo[0],
    selTypeGroup: types_grups[0],
    selControlPeriod: 1,
    kg_ch_date_to: new Date().toISOString().split('T')[0],
    ch_count: '',
    disease: '',
  });
  
  // 3. UI состояние
  const [uiState, setUiState] = useState({
    showComponent: null,
    detailInfoGroup: null,
    shViewBack: null,
    gr_info: {},
    showTabelGroup: '',
    addT: 'invite',
    strS: [],
    arrTypes: {},
    expandedRows: new Set()
  });

  const [loading, setLoading] = useState(false);

  // Константы
  const shNoneInfo = (
    <div className="alert alert-info text-center">
      Не має інформації в обраному періоді
    </div>
  );

  // Вспомогательные функции
  const checkInternationalAgreement = (val) => {
    switch(typeof(val)) {
      case 'boolean':
        return val;
      case 'string':
        return val === 'true';
      default:
        return false;
    }
  };

  const selectElementContents = (el) => {
    const body = document.body;
    let range, sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
      document.execCommand("copy");
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(el);
      range.select();
      range.execCommand("Copy");
    }
  };

  // Функции для работы с раскрывающимися строками
  const toggleRowExpansion = useCallback((index) => {
    setUiState(prev => {
      const newExpandedRows = new Set(prev.expandedRows);
      if (newExpandedRows.has(index)) {
        newExpandedRows.delete(index);
      } else {
        newExpandedRows.add(index);
      }
      return { ...prev, expandedRows: newExpandedRows };
    });
  }, []);

  const isRowExpanded = useCallback((index) => {
    return uiState.expandedRows.has(index);
  }, [uiState.expandedRows]);

  // Инициализация данных
  const initializeGroupTypes = useCallback(() => {
    const groupTypes = [
      {
        "number": 1,
        "ageLimitFrom": 0,
        "ageLimitTo": 1,
        "description": "Перша група раннього віку — від двох місяців до року (до 10 осіб)"
      },
      {
        "number": 2,
        "ageLimitFrom": 1,
        "ageLimitTo": 2,
        "description": "Друга група раннього віку — від 1-го до 2-х років (до 15 осіб)"
      },
      {
        "number": 3,
        "ageLimitFrom": 2,
        "ageLimitTo": 3,
        "description": "Перша молодша група — від 2-х до 3-х років (до 15 осіб)"
      },
      {
        "number": 4,
        "ageLimitFrom": 3,
        "ageLimitTo": 4,
        "description": "Друга молодша група — від 3-х до 4-х років (до 20 осіб)"
      },
      {
        "number": 5,
        "ageLimitFrom": 4,
        "ageLimitTo": 5,
        "description": "Середня група — від 4-х до 5-ти років (до 20 осіб)"
      },
      {
        "number": 6,
        "ageLimitFrom": 5,
        "ageLimitTo": 6,
        "description": "Старша група — від 5-ти до 6-ти років (до 20 осіб)"
      },
      {
        "number": 7,
        "ageLimitFrom": 6,
        "ageLimitTo": 7,
        "description": "Підготовча до школи група — від 6-ти до 7-ми років (до 20 осіб)"
      },
      {
        "number": 8,
        "ageLimitFrom": 3,
        "ageLimitTo": 5,
        "description": "Різновікова"
      },
      {
        "number": 10,
        "ageLimitFrom": 3,
        "ageLimitTo": 5,
        "description": "Різновікова — від 3-х до 5-ти років"
      },
      {
        "number": 11,
        "ageLimitFrom": 3,
        "ageLimitTo": 6,
        "description": "Різновікова — від 3-х до 6-ти років"
      },
      {
        "number": 12,
        "ageLimitFrom": 4,
        "ageLimitTo": 6,
        "description": "Різновікова — від 4-х до 6-ти років"
      },
      {
        "number": 13,
        "ageLimitFrom": 0,
        "ageLimitFromPlusMonth": 6,
        "ageLimitTo": 1,
        "description": "Від 6 місяців до 1 року"
      },
      {
        "number": 14,
        "ageLimitFrom": 1,
        "ageLimitFromPlusMonth": 6,
        "ageLimitTo": 3,
        "description": "Від 1 року і 6 місяців до 3 років"
      }
    ];

    const typesGr = {};
    groupTypes.forEach((item) => {
      let ageFrom = item.ageLimitFrom;
      if (item.ageLimitFromPlusMonth) ageFrom += item.ageLimitFromPlusMonth / 12;
      typesGr[item.number] = ageFrom + '-' + item.ageLimitTo;
    });

    setGrFull(groupTypes);
    setUiState(prev => ({ ...prev, arrTypes: typesGr }));
  }, []);

  const getPeriodYearsAndDistricts = useCallback((isArchive) => {
    groupsStatisticsActions.getPeriods(isArchive, (cursor) => {
      const sortedCurs = cursor.sort((a, b) => {
        if (a._id > b._id) return -1;
        if (a._id < b._id) return 1;
        return 0;
      });

      if (sortedCurs.length > 0) {
        let countSol = 0;
        const distr = [];

        sortedCurs[0].dist.forEach((item) => {
          if (item.match(/Со/) && countSol === 0) {
            countSol += 1;
            distr.push('Солом\'янський');
          } else {
            distr.push(item);
          }
        });

        const distr_sort = distr.sort();

        setYears(sortedCurs);
        setSetDistr(distr_sort);
        setSetSpec(sortedCurs[0].specializations.sort());
        setFilters(prev => ({
          ...prev,
          selYear: sortedCurs[0]._id + ':0',
          selDist: distr_sort[0]
        }));
      }
    }, (err) => alert(`Помилка при отриманні даних щодо груп ${JSON.stringify(err)}`));
  }, []);

  const initData = useCallback((isArchive) => {
    getPeriodYearsAndDistricts(isArchive);
    initializeGroupTypes();
  }, [getPeriodYearsAndDistricts, initializeGroupTypes]);

  // Обработчики изменения фильтров
  const handleFilterChange = useCallback((name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
  }, []);

  const resetDiseaseFilters = useCallback(() => {
    handleFilterChange('disease', '');
  }, [handleFilterChange]);


  // Обработчики событий
const handleYearChange = useCallback((e) => {
  resetDiseaseFilters();
  const info = e.target.value.split(':');
  const yearIndex = parseInt(info[1]);

  if (years[yearIndex]) {
    let countSol = 0;
    const distr = [];

    years[yearIndex].dist.forEach((item) => {
      if (item.match(/Со/) && countSol === 0) {
        countSol += 1;
        distr.push('Солом\'янський');
      } else {
        distr.push(item);
      }
    });

    const distr_sort = distr.sort();

    setSetDistr(distr_sort);
    setSetSpec(years[yearIndex].specializations.sort());
    setFilters(prev => ({
      ...prev,
      selDist: distr_sort[0],
      selYear: e.target.value,
    }));
  }
}, [years, resetDiseaseFilters]);


  const handleCheckboxChange = useCallback((index) => {
    const newStrS = [...uiState.strS];
    newStrS[index].checked = !newStrS[index].checked;
    setUiState(prev => ({ ...prev, strS: newStrS }));
  }, [uiState.strS]);


  // API функции
const getInfoAboutGroups = async () => {
  setLoading(true);
  try {
    const yearValue = filters.selYear.split(":")[0];
    const [yy, mm] = new Date().toISOString().split('T')[0].split('-');
    const mmF = (filters.selControlPeriod >= +mm ? +mm + 12 - filters.selControlPeriod : +mm - filters.selControlPeriod).toString();
    const yyF = filters.selControlPeriod < +mm ? +yy : +yy - 1;

    

    const params = {
      year: yearValue,
      date_to: filters.kg_ch_date_to,
      distr: filters.selDist !== 'all' ? filters.selDist : undefined,
      //spec: filters.selSpec !== 'all' ? filters.selSpec : undefined,
      age_type: filters.selAge !== 'all' ? filters.selAge : undefined,
      ch_count: filters.ch_count !== '' ? filters.ch_count : undefined,
      place_type: filters.selType !== 'all' ? filters.selType : undefined,
      kg_type: filters.selTypeKg !== 'all' ? filters.selTypeKg : undefined,
      gr_type: filters.selTypeGroup !== 'all' ? filters.selTypeGroup : undefined,
      disease: filters.disease !== '' ? filters.disease : undefined, // Добавляем параметр disease
      dateFrom: `${yyF}-${mmF.length > 1 ? mmF : '0' + mmF}-01`
    };


    


    if(filters.disease !== '') {

      const arr_spec = []

      for(let d of filters.disease.split(",")){

        const txt_lbl = filters_tmpl.disease_type.find(f=>f.field == d)?.label || undefined;

        arr_spec.push(txt_lbl);
      }

      params['spec'] = arr_spec.join(",");
      
    }


    if(filters.selSpec !== 'all') {

      const arr_specifics = [];

      for(let d of filters.selSpec.split(",")) {

        const txt_lbl = filters_tmpl.specialization.find(f=>f.field == filters.selSpec)?.groups || undefined;

        arr_specifics.push(txt_lbl);
        
      }

      params['specifics'] = arr_specifics.join(",");

    }
      

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );


    const res = await groupsStatisticsActions.getInfoAboutGroups(filteredParams, isArchive);
    
    if (res.data && res.data.cursor && Array.isArray(res.data.cursor) && res.data.cursor.length > 0) {
      const sortedData = res.data.cursor.sort((a, b) => {
        if (a._id > b._id) return -1;
        if (b._id > a._id) return 1;
        return 0;
      });

      setInfoGr(sortedData);
      setUiState(prev => ({
        ...prev,
        strS: sortedData.map(() => ({ checked: false })),
        expandedRows: new Set()
      }));
    } else {
      setInfoGr([]);
    }
  } catch (error) {
    console.error('Error fetching groups info:', error);
    setInfoGr([]);
  } finally {
    setLoading(false);
  }
};

  const onSubmitSelect = useCallback(async () => {
    const selectedCount = uiState.strS.reduce((a, i) => i.checked ? a + 1 : a, 0);
    if (selectedCount < 1) {
      alert("Жодного садочка не обрано");
      return;
    }

    alert('Обрано для оновлення ' + selectedCount);

    const upd_info = await Promise.all(
      uiState.strS.map(async (el, i) => {
        if (el.checked) {
          return await groupsStatisticsActions.updateReservedPlaces(infoGr[i]._id.kg_id);
        }
        return null;
      })
    );

    if (upd_info) alert('Інформація про резерви оновлена');
  }, [uiState.strS, infoGr]);

  const onSubmitRD = useCallback(async () => {
    const selectedCount = uiState.strS.reduce((a, i) => i.checked ? a + 1 : a, 0);
    if (selectedCount < 1) {
      alert("Жодного садочка не обрано");
      return;
    }

    alert('Обрано для оновлення ' + selectedCount);

    const upd_info = await Promise.all(
      uiState.strS.map(async (el, i) => {
        if (el.checked) {
          const yearValue = filters.selYear.split(":")[0];
          return await groupsStatisticsActions.syncRDInfo(infoGr[i]._id.kg_id, parseInt(yearValue));
        }
        return null;
      })
    );

    alert('Інформація оновлена');
  }, [uiState.strS, infoGr, filters.selYear]);

  // Функции для детальной информации
  const initDetailInfo = useCallback((item_kg) => {
    detailInfo(item_kg);
  }, []);

  const detailInfo = (item) => {

    const sh_tabel = (group) => {
      setUiState(prev => ({
        ...prev,
        showComponent: (
          <div>
            {prev.detailInfoGroup}
            <StatisticaAttendanceGroup 
              kgId={item._id.kg_id}
              kgGroup={group.number}
              group={group}
              isArchive={isArchive}
            />
          </div>
        ),
        addT: 'tarif'
      }));
    };

    const kgel = <a href={'#/objpage/' + item._id.kg_id}>{item._id.number}</a>;
    const titul = <h2 className="text-center">Інформація по групам ЗДО {kgel}</h2>;

    const header = (
      <tr>
        <th scope="col">№</th>
        <th scope="col">Група</th>
        <th scope="col">Спеціалізація</th>
        <th scope="col">Вікова категорія</th>
        <th scope="col" title="Місць(норматив)">м.н.</th>
        <th scope="col" title="Кількість місць повного дня">м.п.</th>
        <th scope="col" title="Кількість місць повного дня(план)">м.п.п.</th>
        <th scope="col" title="Кількість місць короткотривалого">м.к.</th>
        <th scope="col" title="Кількість місць короткотривалого(план)">м.к.</th>
        <th scope="col" title="Кількість місць інклюзії">м.і</th>
        <th scope="col" title="Кількість місць інклюзії(план)">м.і.п.</th>
        <th scope="col" title="Кількість дітей повного дня">д.п.</th>
        <th scope="col" title="Кількість дітей короткотривалого">д.к.</th>
        <th scope="col" title="Кількість дітей інклюзії">д.і.</th>
        <th scope="col" title="Відвідування">від.</th>
        <th scope="col" title="Міжнародний договір">м.д.</th>
        <th scope="col" title="Додатково">д.</th>
      </tr>
    );

    const backF = () => {
      setUiState(prev => ({ ...prev, showComponent: prev.shViewBack }));
    };

    const nav = (
      <div className="row mt-4">
        <div className="col-md-2">
          <button className="btn btn-secondary action-btn" onClick={backF}>Повернутись</button>
        </div>
      </div>
    );

    const tableInfo = item.groups.map((element, index) => {
      let numbPlacesNorm = 0;
      const numbChildr = { standart: 0, 'without-bed': 0, inclusive: 0, inclusiveShort: 0 };

      element.info.forEach((numb) => {
        numbChildr[numb.typePlace] = numb.numb_ch;
      });

      if (element.spec !== 'без спеціалізації' && element.specifics !== TYPE_SANAORNIY) {
        numbPlacesNorm = normalPlaceForGroups.spec[element.spec] || normalPlaceForGroups.spec.default;
      }
      if (element.spec === 'без спеціалізації' && element.specifics !== TYPE_SANAORNIY) {
        numbPlacesNorm = normalPlaceForGroups.wo_spec[element.type] || normalPlaceForGroups.wo_spec.default;
      }
      if (element.specifics === TYPE_SANAORNIY) {
        numbPlacesNorm = normalPlaceForGroups.sanat[element.type] || normalPlaceForGroups.sanat.default;
      }

      return (
        <tr key={index} id={`detail_tr_t${index}`}>
          <td>{index + 1}</td>
          <td>{element.number}</td>
          <td>{element.spec}</td>
          <td>{element.typeName}</td>
          <td>{numbPlacesNorm}</td>
          <td>{+element.number_site.sleepingPlaces + 0}</td>
          <td>{element.planed_site ? +element.planed_site.sleepingPlaces + 0 : ''}</td>
          <td>{+element.number_site.withoutBeds + 0}</td>
          <td>{element.planed_site ? +element.planed_site.withoutBeds + 0 : ''}</td>
          <td>{+element.number_site.inclusive + 0 + element.number_site.inclusiveShort}</td>
          <td>{element.planed_site ? +element.planed_site.inclusive + 0 + element.planed_site.inclusiveShort : ''}</td>
          <td>{numbChildr.standart}</td>
          <td>{numbChildr['without-bed']}</td>
          <td>{numbChildr.inclusive + numbChildr.inclusiveShort}</td>
          <td>{element.attend.count}</td>
          <td>{element.internationalAgreement && checkInternationalAgreement(element.internationalAgreement) ? 'Є' : 'Не має'}</td>
          <td title="Показати табель групи">
            <img 
              src='/img/icon_tabel_24242.png' 
              onClick={() => sh_tabel(element)}
              className="table-icon"
              alt="Табель"
            />
          </td>
        </tr>
      );
    });

    const ret = (
      <div className="statistics-groups-container">
        {titul}
        <div className="row">
          <div className="table-responsive">
            <table className="table table-striped statistics-table statistics-table-striped">
              <thead className="statistics-table-primary">{header}</thead>
              <tbody>{tableInfo}</tbody>
            </table>
          </div>
          {nav}
        </div>
      </div>
    );

    setUiState(prev => ({
      ...prev,
      shViewBack: prev.showComponent,
      detailInfoGroup: ret,
      showComponent: (
        <div>
          {ret}
          {!isArchive && <StatisticaInvites kgId={item._id.kg_id} />}
        </div>
      )
    }));
  };

  // Основная таблица информации с раскрывающимися строками
  const tableInfo = useCallback(() => {
    if (!infoGr || infoGr.length === 0) {
      return shNoneInfo;
    }

    const isSuperAdmin = auth.getData().privilegedUser.role === 'superadmin';
    const res = {
      kg: 0, ngr: 0, numbPlaces: 0, numbPlacesPlan: 0, numberChildrens: 0,
      numberRezerv: 0, numberAttend: 0, numberChildrensYasli: 0, numbPlacesInc: 0,
      numbPlacesShrt: 0, numbPlacesNorm: 0, kyiv: 0, secondName: 0, attnd_period: 0,
      numberChildrenInc: 0, numberFreeInc: 0
    };

    // Функция для рендеринга строки группы
    const renderGroupRow = (group, kgIndex, groupIndex, district) => {
      let numbPlaces = 0;
      let numbPlacesPlan = 0;
      let numberChildrens = 0;
      let numberAttend = 0;
      let numberChildrensYasli = 0;
      let numbPlacesInc = 0;
      let numbPlacesShrt = 0;
      let numbPlacesNorm = 0;
      let numberChildrenInc = 0;
      let numberFreeInc = 0;

      // Расчет данных для одной группы
      Object.keys(group.number_site).forEach((places) => {
        numbPlaces += group.number_site[places];
      });

      if (group.planed_site) {
        Object.keys(group.planed_site).forEach((places) => {
          numbPlacesPlan += group.planed_site[places];
        });
      }

      numbPlacesInc += group.number_site.inclusive + group.number_site.inclusiveShort;
      numbPlacesShrt += group.number_site.withoutBeds;

      if (group.spec !== 'без спеціалізації' && group.specifics !== TYPE_SANAORNIY) {
        numbPlacesNorm += normalPlaceForGroups.spec[group.spec] || normalPlaceForGroups.spec.default;
      }
      if (group.spec === 'без спеціалізації' && group.specifics !== TYPE_SANAORNIY) {
        numbPlacesNorm += normalPlaceForGroups.wo_spec[group.type] || normalPlaceForGroups.wo_spec.default;
      }
      if (group.specifics === TYPE_SANAORNIY) {
        numbPlacesNorm += normalPlaceForGroups.sanat[group.type] || normalPlaceForGroups.sanat.default;
      }

      group.info.forEach((ch) => {
        numberChildrens += ch.numb_ch;
        if ([1, 2, 3, 9, 13, 14].includes(group.type)) {
          numberChildrensYasli += ch.numb_ch;
        }
        if(['inclusive', 'inclusiveShort'].includes(ch.typePlace)) {
          numberChildrenInc += ch.numb_ch;
        }
      });


      numberFreeInc = numbPlacesInc > numberChildrenInc ? numbPlacesInc - numberChildrenInc : 0;

      numberAttend += group.attend.count;

      const numbRes = group.reserv.length;

      const styleColor = (() => {
        if (numberChildrens + numbRes > numbPlaces) {
          return 'vacant-highlight';
        } else if (numberChildrens + numbRes < numbPlaces) {
          return 'available-highlight';
        } else {
          return 'full-highlight';
        }
      })();

      const sh_tabel_group = (groupItem, kgItem) => {
        setUiState(prev => ({
          ...prev,
          showComponent: (
            <StatisticaAttendanceGroup 
              kgId={kgItem._id.kg_id}
              kgGroup={groupItem.number}
              group={groupItem}
              isArchive={isArchive}
            />
          )
        }));
      };

      return (
        <tr key={`group-${kgIndex}-${groupIndex}`} className="table-group-row">
          <td></td>
          {isSuperAdmin && <td></td>}
          <td className="text-muted small ps-4">
            <i className="bi bi-arrow-return-right me-1"></i>
            {group.number}
          </td>
          <td>{district}</td>
          <td className="text-center">1</td>
          <td className={`text-center ${styleColor}`}>{numbPlaces}</td>
          <td className={`text-center ${styleColor}`}>{numbPlacesPlan}</td>
          <td className={`text-center ${styleColor}`}>{numbPlacesNorm}</td>
          <td className="text-center">{numbPlacesInc}</td>
          <td className="text-center">{numbPlacesShrt}</td>
          <td className="text-center">{numberChildrensYasli}</td>
          <td className="text-center">{numberChildrens - numberChildrensYasli}</td>
          <td className="text-center">-</td>
          <td className="text-center">{numbRes}</td>
          <td className="text-center">{numbPlaces - numberChildrens - numbRes}</td>
          <td className="text-center">{numberAttend}</td>
          <td className="text-center">{numberChildrens > 0 ? ((numberAttend / numberChildrens) * 100).toFixed(1) + '%' : '0%'}</td>
          <td className="text-center">-</td>
          <td>{group.spec}</td>
          <td className="text-center">-</td>
          <td>{group.internationalAgreement && checkInternationalAgreement(group.internationalAgreement) ? 'Є' : 'Не має'}</td>
          {['inclusive', 'inclusiveShort'].includes(filters.selType) && (
                      <>
                      <td className="text-center">{numberChildrenInc}</td>
                      <td className="text-center">{numberFreeInc}</td>
                      </>
                    ) }
          <td>
            <button 
              className="btn btn-outline-primary btn-sm action-btn"
              onClick={() => sh_tabel_group(group, infoGr[kgIndex])}
            >
              Деталі
            </button>
          </td>
        </tr>
      );
    };

    const tableGroups = infoGr.map((item, i) => {
      // Расчет агрегированных данных для садика
      let numbPlaces = 0;
      let numbPlacesPlan = 0;
      const specialization = {};
      let numberChildrens = 0;
      let numberAttend = 0;
      let numberChildrensYasli = 0;
      let numbPlacesInc = 0;
      let numbPlacesShrt = 0;
      let numbPlacesNorm = 0;
      let numberChildrenInc = 0;
      let numberFreeInc = 0;

      res.kg += 1;
      res.secondName += item._id.sn || 0;

      item.groups.forEach((elem) => {
        Object.keys(elem.number_site).forEach((places) => {
          numbPlaces += elem.number_site[places];
        });

        if (elem.planed_site) {
          Object.keys(elem.planed_site).forEach((places) => {
            numbPlacesPlan += elem.planed_site[places];
          });
        }

        numbPlacesInc += elem.number_site.inclusive + elem.number_site.inclusiveShort;
        numbPlacesShrt += elem.number_site.withoutBeds;

        if (elem.spec !== 'без спеціалізації') {
          specialization[elem.spec] = (specialization[elem.spec] || 0) + 1;
        }

        if (elem.spec !== 'без спеціалізації' && elem.specifics !== TYPE_SANAORNIY) {
          numbPlacesNorm += normalPlaceForGroups.spec[elem.spec] || normalPlaceForGroups.spec.default;
        }
        if (elem.spec === 'без спеціалізації' && elem.specifics !== TYPE_SANAORNIY) {
          numbPlacesNorm += normalPlaceForGroups.wo_spec[elem.type] || normalPlaceForGroups.wo_spec.default;
        }
        if (elem.specifics === TYPE_SANAORNIY) {
          numbPlacesNorm += normalPlaceForGroups.sanat[elem.type] || normalPlaceForGroups.sanat.default;
        }

        elem.info.forEach((ch) => {
          numberChildrens += ch.numb_ch;
          if ([1, 2, 3, 9, 13, 14].includes(elem.type)) {
            numberChildrensYasli += ch.numb_ch;
          }
          if(['inclusive', 'inclusiveShort'].includes(ch.typePlace)) {
          numberChildrenInc += ch.numb_ch;
         }
        });

        numberAttend += elem.attend.count;
      });

      numberFreeInc = numbPlacesInc > numberChildrenInc ? numbPlacesInc - numberChildrenInc : 0;


      const numbRes = item.groups.reduce((acc, curr) => acc + curr.reserv.length, 0);

      // Обновление итоговых значений
      res.ngr += item.groups.filter(e => e.type !== 15).length;
      res.numbPlaces += numbPlaces;
      res.numbPlacesPlan += numbPlacesPlan;
      res.numberChildrens += numberChildrens;
      res.numberRezerv += numbRes;
      res.numberAttend += numberAttend;
      res.numberChildrensYasli += numberChildrensYasli;
      res.numbPlacesInc += numbPlacesInc;
      res.numbPlacesShrt += numbPlacesShrt;
      res.numbPlacesNorm += numbPlacesNorm;
      res.attnd_period += item.attend_period;
      res.numberChildrenInc += numberChildrenInc;
      res.numberFreeInc += numberFreeInc;

      const styleColor = (() => {
        if (numberChildrens + numbRes > numbPlaces) {
          return 'vacant-highlight';
        } else if (numberChildrens + numbRes < numbPlaces) {
          return 'available-highlight';
        } else {
          return 'full-highlight';
        }
      })();

      if (Object.keys(specialization).length === 0) specialization['не має'] = 1;

      const isExpanded = isRowExpanded(i);

      return (
        <React.Fragment key={i}>
          {/* Основная строка садика */}
          <tr id={`main_tr_t${i}`} className={i % 2 === 0 ? 'statistics-table-even' : ''}>
            <td className="fw-semibold">
              <button 
                className="expand-toggle-btn me-2"
                onClick={() => toggleRowExpansion(i)}
              >
                {isExpanded ? '−' : '+'}
              </button>
              {i + 1}
            </td>
            {isSuperAdmin && (
              <td>
                <input 
                  type='checkbox' 
                  className="form-check-input"
                  checked={uiState.strS[i]?.checked || false}
                  onChange={() => handleCheckboxChange(i)}
                />
              </td>
            )}
            <td className="fw-bold">{item._id.number}</td>
            <td>{item._id.distr}</td>
            <td className="text-center">{item.groups.filter(e => e.type !== 15).length}</td>
            <td className={`text-center ${styleColor}`}>{numbPlaces}</td>
            <td className={`text-center ${styleColor}`}>{numbPlacesPlan}</td>
            <td className={`text-center ${styleColor}`}>{numbPlacesNorm}</td>
            <td className="text-center">{numbPlacesInc}</td>
            <td className="text-center">{numbPlacesShrt}</td>
            <td className="text-center">{numberChildrensYasli}</td>
            <td className="text-center">{numberChildrens - numberChildrensYasli}</td>
            <td className="text-center">{item._id.kyiv || 0}</td>
            <td className="text-center">{numbRes}</td>
            <td className="text-center">{numbPlaces - numberChildrens - numbRes}</td>
            <td className="text-center">{numberAttend}</td>
            <td className="text-center">{numberChildrens > 0 ? ((numberAttend / numberChildrens) * 100).toFixed(1) + '%' : '0%'}</td>
            <td className="text-center">{numberChildrens > 0 ? ((item.attend_period / numberChildrens) * 100).toFixed(1) + '%' : '0%'}</td>
            <td>{Object.keys(specialization).join(', ')}</td>
            <td className="text-center">{item._id.sn || 0}</td>
            <td className="text-center">{item.groups.find(el => el && el.internationalAgreement && checkInternationalAgreement(el.internationalAgreement)) ? 'Є' : 'Не має'}</td>
            {['inclusive', 'inclusiveShort'].includes(filters.selType) && (
                      <>
                      <td className="text-center">{numberChildrenInc}</td>
                      <td className="text-center">{numberFreeInc}</td>
                      </>
                    ) }
            
            
            <td>
              <button 
                className="btn btn-outline-primary btn-sm action-btn"
                onClick={() => initDetailInfo(item)}
              >
                Деталі
              </button>
            </td>
          </tr>
          
          {/* Раскрывающиеся строки с группами */}
          {isExpanded && item.groups.map((group, groupIndex) => 
            renderGroupRow(group, i, groupIndex, item._id.distr )
          )}
        </React.Fragment>
      );
    });

    const yearStudy = filters.selYear ? filters.selYear.split(':')[0] + '/' + (+filters.selYear.split(':')[0] + 1) : '';

    return (
      <div className="statistics-groups-container">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-12">
                {!isArchive && (
                  <h4 className="text-center">
                    Інформація про групи станом на {new Date(filters.kg_ch_date_to).toLocaleDateString('uk-UK')}
                  </h4>
                )}
                {isArchive && (
                  <h4 className="text-center">
                    Інформація про групи минулих років, {yearStudy} навчальний рік
                  </h4>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-12 text-end">
                <button 
                  className="btn btn-outline-secondary btn-sm action-btn"
                  onClick={() => selectElementContents(document.getElementById('tableMainInfoGroupForCopy'))}
                  title="скопіювати таблицю для ексел"
                >
                  <i className="bi bi-file-earmark-excel"></i> Експорт в Excel
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover statistics-table statistics-table-striped statistics-table-hover" id='tableMainInfoGroupForCopy'>
                <thead className="statistics-table-primary">
                  <tr>
                    <th scope="col">№</th>
                    {isSuperAdmin && <th scope='col'/>}
                    <th scope="col">ЗДО</th>
                    <th scope="col">Район</th>
                    <th scope="col">Груп</th>
                    <th scope="col">Місць</th>
                    <th scope="col" title="Місць(план)">М.П.</th>
                    <th scope="col" title="Місць(норматив)">М.Н.</th>
                    <th scope="col" title="Місць інклюзія">М.І.</th>
                    <th scope="col" title="">Місць к-тр</th>
                    <th scope="col">Дітей яслі</th>
                    <th scope="col">Дітей сад</th>
                    <th scope="col">Киян</th>
                    <th scope="col" title="Місць в резерві (надійшли запрошення)">Рез.</th>
                    <th scope="col" title="Вільних місць">Віл.</th>
                    <th scope="col" title="Відвідування, кількість">Відв.к.</th>
                    <th scope="col" title="Відвідування, відсоток від спискового складу">Відв.д.</th>
                    <th scope="col" title="Відвідування за період, відсоток від спискового складу">Період в.</th>
                    <th scope="col" title="Спеціалізація">Сп.</th>
                    <th scope="col" title="Заповнено по батькові">П.Б.</th>
                    <th scope="col" title="Міжнародний договір">Між.Д.</th>
                    {['inclusive', 'inclusiveShort'].includes(filters.selType) && (
                      <>
                      <th scope="col" title="Діти інклюзія">Д.І.</th>
                      <th scope="col" title="Вільних місць інклюзія">В.М.І.</th>
                      </>
                    ) }
                    <th scope="col">Додатково</th>
                  </tr>
                </thead>
                <tbody>{tableGroups}</tbody>
                <tfoot className="table-footer">
                  <tr>
                    <td></td>
                    {isSuperAdmin && <td></td>}
                    <td></td>
                    <td className="fw-bold">Разом:</td>
                    <td className="fw-bold text-center">{res.ngr}</td>
                    <td className="fw-bold text-center">{res.numbPlaces}</td>
                    <td className="fw-bold text-center">{res.numbPlacesPlan}</td>
                    <td className="fw-bold text-center">{res.numbPlacesNorm}</td>
                    <td className="fw-bold text-center">{res.numbPlacesInc}</td>
                    <td className="fw-bold text-center">{res.numbPlacesShrt}</td>
                    <td className="fw-bold text-center">{res.numberChildrensYasli}</td>
                    <td className="fw-bold text-center">{res.numberChildrens - res.numberChildrensYasli}</td>
                    <td className="fw-bold text-center">{res.kyiv}</td>
                    <td className="fw-bold text-center">{res.numberRezerv}</td>
                    <td className="fw-bold text-center">{res.numbPlaces - res.numberChildrens - res.numberRezerv}</td>
                    <td className="fw-bold text-center">{res.numberAttend}</td>
                    <td className="fw-bold text-center">{res.numberChildrens > 0 ? ((res.numberAttend / res.numberChildrens) * 100).toFixed(1) + '%' : '0%'}</td>
                    <td className="fw-bold text-center">{res.numberChildrens > 0 ? ((res.attnd_period / res.numberChildrens) * 100).toFixed(1) + '%' : '0%'}</td>
                    <td></td>
                    <td className="fw-bold text-center">{res.secondName}</td>
                    <td></td>
                    {['inclusive', 'inclusiveShort'].includes(filters.selType) && (
                      <>
                      <td className="fw-bold text-center">{res.numberChildrenInc}</td>
                      <td className="fw-bold text-center">{res.numberFreeInc}</td>
                      </>
                    ) }
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {!isArchive && isSuperAdmin && (
              <div className="row mt-4">
                <div className="col-md-6">
                  <button 
                    className="btn btn-warning me-2 action-btn"
                    onClick={onSubmitSelect}
                  >
                    Оновити резерви у обраних ЗДО
                  </button>
                  <button 
                    className="btn btn-info action-btn"
                    onClick={onSubmitRD}
                  >
                    Оновити дані про ЗДО в РД
                  </button>
                </div>
              </div>
            )}

            <div className="table-footer-note">
              Всього ЗДО: {res.kg} | Груп: {res.ngr} | Дітей: {res.numberChildrens} | 
              Відвідування: {res.numberAttend} ({res.numberChildrens > 0 ? ((res.numberAttend / res.numberChildrens) * 100).toFixed(1) + '%' : '0%'})
            </div>
          </div>
        </div>
      </div>
    );
  }, [infoGr, uiState.strS, uiState.expandedRows, filters, isArchive, isRowExpanded, toggleRowExpansion, handleCheckboxChange, initDetailInfo, onSubmitSelect, onSubmitRD]);

  // Эффекты
  useEffect(() => {
    initData(isArchive);
  }, [initData, isArchive]);

  useEffect(()=>{
    setInfoGr([]);
    setFilters({
    selYear: '',
    selDist: 'all',
    selSpec: 'all',
    selAge: 'all',
    selType: 'all',
    selTypeKg: types_zdo[0],
    selTypeGroup: types_grups[0],
    selControlPeriod: 1,
    kg_ch_date_to: new Date().toISOString().split('T')[0],
    ch_count: '',
    disease: '',
  })
  }, [isArchive])

  // Обновляем отображение таблицы при изменении данных
  useEffect(() => {
    if (infoGr.length > 0) {
      const tableComponent = tableInfo();
      setUiState(prev => ({ ...prev, showComponent: tableComponent }));
    } else {
      setUiState(prev => ({ ...prev, showComponent: shNoneInfo }));
    }
  }, [infoGr, tableInfo]);

  

const handleDistChange = useCallback((e) => {
  resetDiseaseFilters();
  handleFilterChange('selDist', e.target.value);
}, [handleFilterChange, resetDiseaseFilters]);


  const handleAgeChange = useCallback((e) => {
    handleFilterChange('selAge', e.target.value);
  }, [handleFilterChange]);

  const handleTypeChange = useCallback((e) => {
    handleFilterChange('selType', e.target.value);
  }, [handleFilterChange]);

  const handleCountChange = useCallback((e) => {
    if (e.target.value.match(/^[=]{0,1}[\d]{0,2}[-]{0,1}[\d]{0,2}$/)) {
      handleFilterChange('ch_count', e.target.value);
    } else {
      handleFilterChange('ch_count', '');
    }
  }, [handleFilterChange]);


const handleDiseaseSpecializationChange = useCallback((newFilters) => {
  
  // Сбрасываем фильтр заболеваний при изменении специализации
  handleFilterChange('disease', '');
  
  const selectedSpec = Object.keys(newFilters.specialization).find(
    key => newFilters.specialization[key]
  );
  handleFilterChange('selSpec', selectedSpec || 'all');
  
  // Формируем строку заболеваний из выбранных чекбоксов
  const selectedDiseases = Object.keys(newFilters.disease_type).filter(
    key => newFilters.disease_type[key]
  );
  
  if (selectedDiseases.length > 0) {
    handleFilterChange('disease', selectedDiseases.join(','));
  }
}, [handleFilterChange]);

const ActiveFiltersInfo = () => {
  if (!filters.disease && filters.selSpec === 'all') return null;
  
  return (
    <div className="active-filters-info mb-3 p-2 bg-light rounded">
      <small className="text-muted">
        <strong>Активні фільтри:</strong>
        {filters.selSpec !== 'all' && ` Спеціалізація: ${filters.selSpec}`}
        {filters.disease && ` | Захворювання: ${filters.disease}`}
      </small>
    </div>
  );
};

  const CustomDiseaseSpecializationFilter = ({ filters, setFilters, ...props }) => {
  return (
    <div className="form-check-container">
      <DiseaseSpecializationFilter 
        filters={filters}
        setFilters={setFilters}
        {...props}
      />
    </div>
  );
  };

  return (
    <div className="container-fluid statistics-groups-container" id={id}>
      <div className="card shadow-sm">
        <div className="card-body">
          {/* Блок фільтрів з сіткою 4х3 з фіксованою висотою */}
          <div className="filters-grid-container">
            <div className="filters-grid">
              {/* Перший рядок */}
              <div className="filter-item">
                <label htmlFor="studyYear" className="statistics-label">Навчальний рік:</label>
                <select 
                  id="studyYear"
                  className="statistics-form-control" 
                  value={filters.selYear} 
                  onChange={handleYearChange}
                >
                  {years.map((elem, index) => (
                    <option key={index} value={elem._id + ':' + index}>
                      {elem._id}/{elem._id + 1}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label htmlFor="district" className="statistics-label">Район</label>
                <select 
                  id="district"
                  className="statistics-form-control" 
                  value={filters.selDist} 
                  onChange={handleDistChange}
                >
                  {setDistr.map((dist, index) => (
                    <option key={index} value={dist}>{dist}</option>
                  ))}
                  <option value='all'>всі райони</option>
                </select>
              </div>

              <div className="filter-item">
                <label htmlFor="ageCategory" className="statistics-label">Вікова категорія</label>
                <select 
                  id="ageCategory"
                  className="statistics-form-control" 
                  value={filters.selAge} 
                  onChange={handleAgeChange}
                >
                  {gr_full.map((group, index) => (
                    <option key={index} value={group.number}>{group.description}</option>
                  ))}
                  <option value='all'>всі категорії</option>
                </select>
              </div>

              {/* Спеціалізація - займає три рядки з фіксованою висотою */}
              <div className="filter-item filter-item-triple-row">
                <label className="statistics-label">Спеціалізація</label>
                <div className="specialization-container">
                  <DiseaseSpecializationFilter
                    typeFilter='specialist' 
                    filters={{
                      specialization: {
                        general: filters.selSpec === 'general',
                        combined: filters.selSpec === 'combined', 
                        sanatorium: filters.selSpec === 'sanatorium',
                        special: filters.selSpec === 'special'
                      },
                      disease_type: filters.disease ? filters.disease.split(',').reduce((acc, disease) => {
                        acc[disease] = true;
                        return acc;
                      }, {}) : {}
                    }}
                    setFilters={handleDiseaseSpecializationChange}
                    layout="single"
                    showTitle={false}
                    className="statistics-specialization-filter"
                  />
                </div>
              </div>
              {/* Другий рядок */}
              <div className="filter-item">
                <label htmlFor="placeType" className="statistics-label">Тип місць</label>
                <select 
                  id="placeType"
                  className="statistics-form-control" 
                  value={filters.selType} 
                  onChange={handleTypeChange}
                >
                  <option value='all'>будь-яка</option>
                  {types_places.map((spec, index) => (
                    <option key={index} value={spec.value}>{spec.name}</option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label htmlFor="childrenCount" className="statistics-label">Кількість дітей</label>
                <input 
                  id="childrenCount"
                  className="statistics-form-control" 
                  type='text' 
                  placeholder="від-до, наприклад 5-20" 
                  value={filters.ch_count} 
                  onChange={handleCountChange}
                />
              </div>

              <div className="filter-item">
                <label htmlFor="kgType" className="statistics-label">Тип ЗДО</label>
                <select 
                  id="kgType"
                  className="statistics-form-control" 
                  value={filters.selTypeKg} 
                  onChange={(e) => handleFilterChange('selTypeKg', e.target.value)}
                >
                  {types_zdo.map((type, index) => (
                    <option key={index} value={type}>{type}</option>
                  ))}
                  <option value='all'>всі типи</option>
                </select>
              </div>

              {/* Порожній простір під спеціалізацією */}
              <div className="filter-item"></div>
              <div className="filter-item"><button 
                className="btn btn-primary px-5 action-btn"
                onClick={getInfoAboutGroups}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Завантаження...
                  </>
                ) : 'Показати'}
              </button></div>

              

              

              

              {/* Порожній простір під спеціалізацією */}
             
            </div>
          </div>

          <div className='row mt-4'>
            <div className="col-md-12 text-center">
              
            </div>
          </div>

          <div className="mt-4">
            {uiState.showComponent}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticaGroups;